const scroll=evt=>{
    const obj=evt.target
    if(obj['@@scrollTopI']<obj.scrollTop && obj.scrollHeight-obj.clientHeight-obj.scrollTop<=obj['@@bottom']){
       if(obj['@@callback'])obj['@@callback']()
    }
    obj['@@scrollTopI']=obj.scrollTop
}
/** binding {cbk:'执行方法',bottom:距离底部 默认150} */
export default {
    bind(el, binding) {
        console.log(binding);
        el['@@scrollTopI']=0
        el['@@callback']=binding.value.cbk
        el['@@bottom']=binding.value.bottom||150
        el.addEventListener('scroll', scroll,false)
    },
    update(el, binding) {
        if(!el['@@scrollTopI']){
            el['@@scrollTopI']=0
            el['@@callback']=binding.value.cbk
            el['@@bottom']=binding.value.bottom||150
        }
        el.removeEventListener('scroll', scroll, false)
        el.addEventListener('scroll', scroll)
    },
    unbind(el) {
        el.removeEventListener('scroll', scroll, false)
    }
}